import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AuthStateService {
    /**
     * Why Auth0 refused the last login (`error=access_denied` on the callback), as the Action
     * phrased it in `error_description`. Undefined when the last callback was not a refusal.
     */
    public readonly loginRefusal = signal<string | undefined>(undefined);

    /** Phase 1: Auth0 loaded, JWT decoded, user identity known */
    private readonly authComplete$ = new BehaviorSubject<boolean>(false);

    /** Phase 2: Tenant data fetched from API */
    private readonly initializationComplete$ = new BehaviorSubject<boolean>(false);

    public setAuthComplete(): void {
        this.authComplete$.next(true);
    }

    public waitForAuth(): Observable<boolean> {
        return this.authComplete$.pipe(
            filter(complete => complete),
            take(1)
        );
    }

    public setInitializationComplete(): void {
        this.initializationComplete$.next(true);
    }

    public waitForInitialization(): Observable<boolean> {
        return this.initializationComplete$.pipe(
            filter(complete => complete),
            take(1)
        );
    }

    public setLoginRefusal(description: string): void {
        this.loginRefusal.set(description);
    }
}
